module.exports = __webpack_public_path__ + "img/book.e9c62763.png";